import styled from "styled-components";
import { theme } from "../theme/semanticTheme";

/**
 * Atom: Badge – inline pill. Semantic defaults: success=green, warning=processing (yellow-amber), error=fail (red).
 */
const variants = {
  success: {
    bg: theme.colors.success,
    color: "#fff",
  },
  error: {
    bg: theme.colors.error,
    color: "#fff",
  },
  warning: {
    bg: theme.colors.warning,
    color: "#fff",
  },
  accent: {
    bg: theme.colors.accent,
    color: "#fff",
  },
  neutral: {
    bg: theme.colors.textMuted,
    color: "#fff",
  },
};

export const Badge = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 999px;
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.statusBadge.fontSize};
  font-weight: ${theme.typography.statusBadge.fontWeight};
  line-height: ${theme.typography.statusBadge.lineHeight};
  background: ${(p) => (variants[p.variant] || variants.neutral).bg};
  color: ${(p) => (variants[p.variant] || variants.neutral).color};
`;
